module.exports = __webpack_public_path__ + "bffb005d16c1267ab0021961c6afa35c.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/outlined/outlined.woff2
 ** module id = ./src/styles/fonts/outlined/outlined.woff2
 ** module chunks = 0
 **/